const productContent = document.getElementsByClassName(
  'product__content'
)[0];
const sprStarRating =
  document.getElementsByClassName('spr-starrating')[0];

if (!productContent && !sprStarRating) {
  if (productContent.classList.contains('text-center')) {
    sprStarRating.style.justifyContent = 'center';
  } else if (productContent.classList.contains('text-right')) {
    sprStarRating.style.justifyContent = 'flex-end';
  } else if (productContent.classList.contains('text-left')) {
    sprStarRating.style.justifyContent = 'flex-start';
  }
}

if (!customElements.get('product-sticky-atc')) {
  customElements.define(
    'product-sticky-atc',
    class ProductStickyAtc extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const originalSubmit = document.querySelector('.product-selector__submit');

        if (!originalSubmit) return;

        const stickySubmit = this.querySelector('.product-selector__submit');
        if (!stickySubmit) return;

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              stickySubmit.style.display = 'none';
            } else {
              stickySubmit.style.display = '';
            }
          },
          { threshold: 0.01 }
        );

        observer.observe(originalSubmit);
      }
    }
  );
}
